import * as React from "react";

function SvgOnesignal(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 256 236"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      {...{ ...props, ref }}
    >
      <path
        d="M128.344 0C57.58 0 0 57.581 0 128.344c0 45.094 23.588 84.637 58.275 107.531l6.244-4.162c1.387-.694 3.469-2.082 4.856-2.775 2.081-.694 4.163-2.082 5.55-2.775 2.081-.694 4.163-1.388 6.244-2.775 1.387-.694 3.469-1.388 4.856-2.082 2.081-.693 4.856-1.387 6.938-2.081 2.08-.694 3.468-.694 5.55-1.387 2.08-.694 3.468-.694 5.55-1.388 2.08-.694 4.162-.694 6.243-.694 2.082 0 4.857-.693 6.938-.693V138.75h-6.938v-13.875h34.688v91.575c19.425 2.775 36.769 9.713 52.725 19.425 35.381-22.894 58.275-62.437 58.275-107.531C256.688 57.58 199.106 0 128.344 0zM166.5 128.344c0-20.813-17.344-38.156-38.156-38.156-20.813 0-38.156 17.343-38.156 38.156 0 14.569 8.325 27.75 20.812 33.994v7.63c-15.956-6.937-27.75-22.893-27.75-41.624 0-24.975 20.119-45.094 45.094-45.094s45.094 20.119 45.094 45.094c0 15.956-8.325 29.831-20.813 38.156v-8.325c8.325-7.631 13.875-18.037 13.875-29.831zm-13.875 75.619v-7.632c28.444-9.712 48.563-36.768 48.563-68.681 0-39.544-32.607-72.15-72.844-72.15-40.238 0-72.844 32.606-72.844 72.844 0 33.994 23.588 63.131 55.5 70.762v6.938c-35.381-7.631-62.437-39.544-62.437-77.7 0-44.4 35.38-79.781 79.78-79.781s79.782 35.38 79.782 79.78c0 35.382-23.587 65.907-55.5 75.62z"
        fill="#E44A49"
      />
    </svg>
  );
}

export default React.forwardRef(SvgOnesignal);
